/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdGroupTargetingDto } from "./AdGroupTargetingDto";
export type UpdateAdGroupDto = {
  /**
   * 광고그룹명
   */
  name?: string;
  /**
   * 광고 타입
   */
  adType?: UpdateAdGroupDto.adType;
  /**
   * 단가
   */
  unitPrice?: number;
  /**
   * 타겟팅 설정
   */
  targeting?: AdGroupTargetingDto;
  /**
   * 상태
   */
  status?: UpdateAdGroupDto.status;
};
export namespace UpdateAdGroupDto {
  /**
   * 광고 타입
   */
  export enum adType {
    HALF_VIEW_CPE = "HALF_VIEW_CPE",
    HALF_VIEW_CPM = "HALF_VIEW_CPM",
    LIGHT_VIEW_CPE = "LIGHT_VIEW_CPE",
    LIGHT_VIEW_CPM = "LIGHT_VIEW_CPM",
    CPQ = "CPQ",
    TOP_BANNER = "TOP_BANNER",
    EXCHANGE = "EXCHANGE",
    QUIZ_CREATION = "QUIZ_CREATION",
  }
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
